/** Keep in sync with document-microservice/pascale/cost-centers/resolveWinningDocumentRule.ts */

const HONORARIO_DOCUMENT_CODES = [0, 1, '0', '1'];

export const normalizeRut = (rut) => {
  if (!rut) return '';
  return String(rut)
    .trim()
    .toUpperCase()
    .replace(/\./g, '')
    .replace(/-/g, '')
    .replace(/\s+/g, '');
};

export function documentSubTypesForDoc(document) {
  const meta = document?.meta || {};
  const obligationTypeEarly = String(meta.type || '').toLowerCase();
  const isBhRetentionObligation =
    document?.documentType === 'OBLIGATION' &&
    (obligationTypeEarly === 'retencionboletashonorarios' ||
      obligationTypeEarly === 'retencion_boletas_honorarios');
  const documentCode = meta.documentCode;
  const documentSubType =
    documentCode != null && HONORARIO_DOCUMENT_CODES.includes(documentCode) ? 'HONORARIO' : 'DTE';
  const ruleDocumentSubType = isBhRetentionObligation ? 'HONORARIO' : documentSubType;
  return { ruleDocumentSubType };
}

export function filterRuleBySubType(rule, ruleDocumentSubType) {
  if (ruleDocumentSubType === 'HONORARIO') {
    return rule.documentSubType === 'HONORARIO';
  }
  return rule.documentSubType == null || rule.documentSubType === 'DTE';
}

export function findContactDocumentRule(document, rules, isReceived, rutKey, ruleDocumentSubType) {
  let matchingRules = rules.filter(
    (rule) =>
      rule.ruleType === 'DOCUMENT' &&
      rule.isEnabled &&
      rule.isReceived === isReceived &&
      !rule.isGlobalDocument &&
      normalizeRut(rule.contactRut) === rutKey &&
      filterRuleBySubType(rule, ruleDocumentSubType),
  );
  if (!matchingRules.length) return null;
  matchingRules.sort((a, b) => (a.priority || 999) - (b.priority || 999));
  return matchingRules[0];
}

export function findGlobalDocumentRule(document, rules, isReceived, ruleDocumentSubType) {
  return (
    rules.find(
      (rule) =>
        rule.ruleType === 'DOCUMENT' &&
        rule.isEnabled &&
        rule.isGlobalDocument === true &&
        rule.isReceived === isReceived &&
        filterRuleBySubType(rule, ruleDocumentSubType),
    ) ?? null
  );
}

export function findAgendaDocumentRule(document, rules, ruleDocumentSubType) {
  const rawAgendaId = Array.isArray(document.agendaId) ? document.agendaId[0] : document.agendaId;
  if (!rawAgendaId) return null;
  const agendaIdStr = String(rawAgendaId);
  return (
    rules.find(
      (rule) =>
        rule.ruleType === 'DOCUMENT' &&
        rule.isEnabled &&
        rule.agendaId?.toString() === agendaIdStr &&
        filterRuleBySubType(rule, ruleDocumentSubType),
    ) ?? null
  );
}

/**
 * Same order as Pascale worker: contact → global → agenda.
 * Without RUT: agenda only (never global).
 * documentExceptions do not discard the rule; they override accountKey at emission time.
 */
export function resolveWinningDocumentRule(document, rules) {
  if (!document || !rules?.length) return null;

  const meta = document.meta || {};
  const isReceived = meta.isReceived === true;
  const counterpartyRut = isReceived ? meta.issuerId : meta.receiverId;
  const { ruleDocumentSubType } = documentSubTypesForDoc(document);
  const rutKey = normalizeRut(counterpartyRut);

  if (rutKey) {
    return (
      findContactDocumentRule(document, rules, isReceived, rutKey, ruleDocumentSubType) ??
      findGlobalDocumentRule(document, rules, isReceived, ruleDocumentSubType) ??
      findAgendaDocumentRule(document, rules, ruleDocumentSubType) ??
      null
    );
  }

  return findAgendaDocumentRule(document, rules, ruleDocumentSubType) ?? null;
}
